import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Completely disable all service workers and remove PWA errors
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    })
    .catch(() => {});
}

// Remove beforeinstallprompt warnings if PWA event is triggered
window.addEventListener("beforeinstallprompt", (e) => {
  // Prevent Chrome from showing the install banner
  e.preventDefault();
});

// CRA performance measurement
reportWebVitals();
// rebuild
